module.exports = global.EventSource;



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/transport/browser/eventsource.js
// module id = 196
// module chunks = 0